import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './styles.module.scss';

interface BackButtonProps {
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button className={cn(styles.backButton, className)} onClick={() => navigate(-1)}>
      <span className={styles.backArrow}>&#8249;</span>
      {t('common.goBack')}
    </button>
  );
};

export default BackButton;
